import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Sedisce prihodnosti",
  "description": "",
  "published": "2007-02-04T00:00:00.000Z",
  "redirect_from": ["/blog/sedisce-prihodnosti/swizec/292"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://www.videosift.com"
      }}>{`Via: `}<em parentName="a">{`VideoSift`}</em></a></p>
    <p>{`Besede ne morejo opisati obsega moje zelje po lastenju te carobne stvari.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      